import React from 'react';

import { useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';

import { Col, Container, FormLabel, Row, Form, Table } from 'react-bootstrap';
import { ApiDelete, ApiGet, ApiPatch, ApiPost } from '../../helper/API/ApiData';
import { Controller, useForm } from "react-hook-form"
import FormInput from '../../components/form/FormInput';

import { toast } from 'react-toastify';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode } from 'primereact/api';
import { getHeading, handleError } from '../../utils/helper';
import { Card } from 'primereact/card';
import { FormHelperText, TextField } from '@mui/material';
import { Calendar } from 'primereact/calendar';
import { classNames } from 'primereact/utils';
import { SelectButton } from 'primereact/selectbutton';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { RadioButton } from 'primereact/radiobutton';
import { MultiSelect } from 'primereact/multiselect';

const REPEAT_ON = [
    { name: 'Sunday', value: 0 },
    { name: 'Monday', value: 1 },
    { name: 'Tuesday', value: 2 },
    { name: 'Wednesday', value: 3 },
    { name: 'Thursday', value: 4 },
    { name: 'Friday', value: 5 },
    { name: 'Saturday', value: 6 },
];
const REPEAT_TYPE = [
    { name: 'Days', code: 1 },
    { name: 'Weeks', code: 2 },
    { name: 'Months', code: 3 },
];
export const AddUpdateShgTraining = () => {

    const navigate = useNavigate()
    const { id } = useParams()

    const shgTrainingId = new URLSearchParams(window.location.search).get("id")
    const isUpdateRequest = !!shgTrainingId

    const [updateType, setUpdateType] = useState('thisEvent')

    const [showRepeatOn, setShowRepeatOn] = useState(false)
    const [showConfirmDialog, setShowConfirmDialog] = useState(false)

    const [shgs, setShgs] = useState([])


    useEffect(() => {

        // Get all shgs
        ApiGet('shg')
            .then((res: any) => {
                if (res?.status === 200) {
                    setShgs(res.data.map((shg: { id: string; name: string; }) => ({
                        id: shg.id,
                        name: shg.name
                    })))
                }
            })
            .catch((error) => {
                handleError(error)
            })

        if (isUpdateRequest) {
            ApiGet(`training/id/${shgTrainingId}`)
                .then((res: any) => {
                    if (res?.status === 200) {
                        const shgTrainingData = res.data[0]
                        const selectedRepeatType = REPEAT_TYPE.find((type) => type.code === shgTrainingData.recurrence.repeat_type)
                        setValue("shg", { id: shgTrainingData.shg.id, name: shgTrainingData.shg.name }, { shouldValidate: true, shouldTouch: true })
                        setValue("start_date", new Date(shgTrainingData.start_timestamp), { shouldValidate: true, shouldTouch: true })
                        setValue("end_date", new Date(shgTrainingData.recurrence.end_date), { shouldValidate: true, shouldTouch: true })
                        setValue("start_time", new Date(shgTrainingData.start_timestamp), { shouldValidate: true, shouldTouch: true })
                        setValue("end_time", new Date(shgTrainingData.end_timestamp), { shouldValidate: true, shouldTouch: true })
                        setValue("repeat_every", shgTrainingData.recurrence.repeat_every, { shouldValidate: true, shouldTouch: true })
                        setValue("repeat_on", shgTrainingData.recurrence.repeat_on, { shouldValidate: true, shouldTouch: true })
                        setValue("repeat_type", selectedRepeatType, { shouldValidate: true, shouldTouch: true })
                        handleRepeatTypeChange(selectedRepeatType)
                        setValue("name_of_trainer", shgTrainingData["name_of_trainer"], { shouldValidate: true, shouldTouch: true });
                        setValue("partner_company", shgTrainingData["partner_company"], { shouldValidate: true, shouldTouch: true });
                        setValue("name_of_capacity_building_training_topics", shgTrainingData["name_of_capacity_building_training_topics"], { shouldValidate: true, shouldTouch: true });
                    }
                })
                .catch((error) => {
                    handleError(error)
                    return error
                })
        }
    }, [])

    const {
        handleSubmit,
        control,
        formState: { errors },
        reset,
        setValue,
        setError,
        getValues,
    } = useForm()

    const onSubmit = (data: any) => {
        console.log("🚀 ~ onSubmit ~ data:", data)
        if (isUpdateRequest) {
            setShowConfirmDialog(true)
        }
        else {
            ApiPost(`training/add`, data)
                .then((res: any) => {
                    if (res.status === 200) {
                        toast.success("Successfully created SHG training")
                        // Clear all fields
                        reset()
                        navigate(`/shgadmin/trainings`)

                    }
                }).catch((error) => {
                    if (error.status === 400 && error.code === 'validation_error') {
                        if (error.data.validation !== undefined) {
                            setError(error.data.validation.body.keys[0],
                                { type: "server", message: error.data.validation.body.message },
                                { shouldFocus: true })
                        }
                        if (error.data.data !== undefined) {
                            setError(error.data.data.validation.body.keys[0],
                                { type: "server", message: error.data.data.validation.body.message },
                                { shouldFocus: true })
                        }
                    }

                    return error
                })
        }
    }

    const getFormErrorMessage = (name: string) => {
        return errors[name] ? <small className="p-error">{errors[name]?.message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const handleRepeatTypeChange = (type: { name: string; code: number } | undefined) => {
        if (type?.code === 2) {
            setShowRepeatOn(true)
        }
        else {
            setShowRepeatOn(false)
        }
    }

    const showTemplate = (data: any) => {
        // confirmDialog({
        //     header: 'Confirmation',
        //     message: (
        //         <div className="d-flex align-items-center">
        //             <div className="d-flex align-items-center">
        //                 <RadioButton
        //                     inputId="thisEvent"
        //                     name="thisEvent"
        //                     value="thisEvent"
        //                     onChange={(e) => {
        //                         setUpdateType(e.value)
        //                         console.log("🚀 ~ showTemplate ~ e.value:", e.value)
        //                     }}
        //                     checked={updateType === 'thisEvent'}
        //                 />
        //                 <label htmlFor="thisEvent" className="ml-2">Update this Training</label>
        //             </div>
        //             <div className="d-flex align-items-center">
        //                 <RadioButton
        //                     inputId="allEvent"
        //                     name="allEvent"
        //                     value="allEvent"
        //                     onChange={(e) => setUpdateType(e.value)}
        //                     checked={updateType === 'allEvent'} />
        //                 <label htmlFor="allEvent" className="ml-2">All Trainings</label>
        //             </div>
        //         </div>
        //     ),
        //     accept: () => accept(data),
        //     reject
        // });
    };

    const accept = () => {
        const formData = getValues()
        formData['updateThisEvent'] = updateType === 'thisEvent'

        ApiPatch(`training/${shgTrainingId}`, formData)
            .then((res: any) => {
                if (res.status === 200) {
                    toast.success("Successfully updated SHG Training")
                    navigate(`/shgadmin/trainings`)
                }
            }).catch((error) => {
                if (error.status === 400 && error.code === 'validation_error') {
                    if (error.data.validation !== undefined) {
                        setError(error.data.validation.body.keys[0],
                            { type: "server", message: error.data.validation.body.message },
                            { shouldFocus: true })
                    }
                    if (error.data.data !== undefined) {
                        setError(error.data.data.validation.body.keys[0],
                            { type: "server", message: error.data.data.validation.body.message },
                            { shouldFocus: true })
                    }
                }
                return error
            })
    };

    const reject = () => {
        setShowConfirmDialog(false)
    };

    const messageTemplate = (
        <div className="flex align-items-between ms-0">
            <div className="flex align-items-center mb-4">
                <RadioButton
                    inputId="thisEvent"
                    name="thisEvent"
                    value="thisEvent"
                    onChange={(e) => {
                        setUpdateType(e.value)
                        console.log("🚀 ~ showTemplate ~ e.value:", e.value)
                    }}
                    checked={updateType === 'thisEvent'}
                />
                <label htmlFor="thisEvent" className="ms-2">Update this Training</label>
            </div>
            <div className="flex align-items-center mt-4">
                <RadioButton
                    inputId="allEvent"
                    name="allEvent"
                    value="allEvent"
                    onChange={(e) => setUpdateType(e.value)}
                    checked={updateType === 'allEvent'} />
                <label htmlFor="allEvent" className="ms-2">All Trainings</label>
            </div>
        </div>
    )

    const handleShgChange = (data: any) => {

    }

    return (
        <Container fluid>
            <h3 className='heading-txt m-3'>{isUpdateRequest ? "Update Shg Training" : "Add Shg Training"}</h3>
            <Card className="p-3">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="mb-3 d-flex justify-content-center">
                        <Col xl={3} lg={3} md={3} className="mb-3">
                            <Controller
                                name={"shg"}
                                rules={{
                                    required: true,
                                    maxLength: 255
                                }}
                                defaultValue=""
                                control={control}
                                render={({ field: { ref, ...field }, fieldState }) =>
                                    <Dropdown
                                        id={field.name}
                                        value={field.value}
                                        optionLabel="name"
                                        options={shgs}
                                        disabled={isUpdateRequest}
                                        focusInputRef={ref}
                                        placeholder="Select SHG"
                                        style={{ width: "100%" }}
                                        onChange={(e) => {
                                            field.onChange(e.value)
                                        }}
                                        className={classNames({ 'p-invalid': fieldState.error })}
                                    />
                                    // <TextField
                                    //     label={getHeading("name_of_trainer")}
                                    //     inputRef={ref}
                                    //     fullWidth
                                    //     error={!!errors["name_of_trainer"]}
                                    //     helperText={errors["name_of_trainer"] ?
                                    //         (errors["name_of_trainer"]?.type === "maxLength" ?
                                    //             `Maximum length exceeded (255 characters allowed)`
                                    //             : errors["name_of_trainer"]?.type === "required" ?
                                    //                 "This field is required" : errors["name_of_trainer"]?.message)
                                    //         : ""}
                                    // />
                                }
                            />
                        </Col>
                        <Col xl={3} lg={3} md={3} className="mb-3">
                            <Controller
                                name={"name_of_trainer"}
                                rules={{
                                    required: true,
                                    maxLength: 255
                                }}
                                defaultValue=""
                                control={control}
                                render={({ field: { ref, ...field } }) =>
                                    <TextField
                                        {...field}
                                        label={getHeading("name_of_trainer")}
                                        inputRef={ref}
                                        fullWidth
                                        error={!!errors["name_of_trainer"]}
                                        helperText={errors["name_of_trainer"] ?
                                            (errors["name_of_trainer"]?.type === "maxLength" ?
                                                `Maximum length exceeded (255 characters allowed)`
                                                : errors["name_of_trainer"]?.type === "required" ?
                                                    "This field is required" : errors["name_of_trainer"]?.message)
                                            : ""}
                                    />
                                }
                            />
                        </Col>
                        <Col xl={3} lg={3} md={3} className="mb-3">
                            <Controller
                                name={"partner_company"}
                                rules={{
                                    required: true,
                                    maxLength: 255
                                }}
                                defaultValue=""
                                control={control}
                                render={({ field: { ref, ...field } }) =>
                                    <TextField
                                        {...field}
                                        label={getHeading("partner_company")}
                                        inputRef={ref}
                                        fullWidth
                                        error={!!errors["partner_company"]}
                                        helperText={errors["partner_company"] ?
                                            (errors["partner_company"]?.type === "maxLength" ?
                                                `Maximum length exceeded (255 characters allowed)`
                                                : errors["partner_company"]?.type === "required" ?
                                                    "This field is required" : errors["partner_company"]?.message)
                                            : ""}
                                    />
                                }
                            />
                        </Col>
                        <Col xl={3} lg={3} md={3} className="mb-3">
                            <Controller
                                name={"name_of_capacity_building_training_topics"}
                                rules={{
                                    required: true,
                                    maxLength: 255
                                }}
                                defaultValue=""
                                control={control}
                                render={({ field: { ref, ...field } }) =>
                                    <TextField
                                        {...field}
                                        label={getHeading("name_of_capacity_building_training_topics")}
                                        inputRef={ref}
                                        fullWidth
                                        error={!!errors["name_of_capacity_building_training_topics"]}
                                        helperText={errors["name_of_capacity_building_training_topics"] ?
                                            (errors["name_of_capacity_building_training_topics"]?.type === "maxLength" ?
                                                `Maximum length exceeded (255 characters allowed)`
                                                : errors["name_of_capacity_building_training_topics"]?.type === "required" ?
                                                    "This field is required" : errors["name_of_capacity_building_training_topics"]?.message)
                                            : ""}
                                    />
                                }
                            />
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col xl={3} lg={3} md={3} >
                            <Controller
                                name="start_date"
                                control={control}
                                rules={{ required: 'Date is required.' }}
                                render={({ field, fieldState }) => (
                                    <div className="d-flex flex-column justify-content-center">
                                        <span className="p-float-label">
                                            <Calendar inputId={field.name} value={field.value} onChange={field.onChange} dateFormat="dd/mm/yy" style={{ width: '100%' }} className={classNames({ 'p-invalid': fieldState.error })} />
                                            <label htmlFor={field.name}>Start Date</label>
                                        </span>
                                        {getFormErrorMessage(field.name)}
                                    </div>
                                )}
                            />
                        </Col>
                        <Col xl={3} lg={3} md={3} >
                            <Controller
                                name={"start_time"}
                                control={control}
                                rules={{
                                    required: "This field is required",
                                    pattern: {
                                        value: /^\d{4}-\d{2}-\d{2}$/, // Validate the format (yyyy-MM-DD)
                                        message: 'Invalid date format (yyyy-MM-DD)'
                                    }

                                }}
                                render={({ field, fieldState }) => (
                                    <div className="d-flex flex-column justify-content-center">
                                        <span className="p-float-label">

                                            <Calendar timeOnly inputId={field.name}
                                                value={field.value}
                                                onChange={field.onChange}
                                                className={classNames({ 'p-invalid': fieldState.error })}
                                                style={{ width: '100%' }}
                                            />
                                            <label htmlFor={field.name}>Start Time</label>
                                        </span>
                                        {getFormErrorMessage(field.name)}
                                    </div>
                                )}
                            />
                        </Col>
                        <Col xl={3} lg={3} md={3}>
                            <Controller
                                name={"end_time"}
                                control={control}
                                rules={{
                                    required: "This field is required",
                                    pattern: {
                                        value: /^\d{4}-\d{2}-\d{2}$/, // Validate the format (yyyy-MM-DD)
                                        message: 'Invalid date format (yyyy-MM-DD)'
                                    }

                                }}
                                render={({ field, fieldState }) => (
                                    <div className="d-flex flex-column justify-content-center">
                                        <span className="p-float-label">

                                            <Calendar
                                                timeOnly
                                                showMinMaxRange={true}
                                                inputId={field.name}
                                                value={field.value}
                                                onChange={field.onChange}
                                                className={classNames({ 'p-invalid': fieldState.error })}
                                                style={{ width: '100%' }}
                                            />
                                            <label htmlFor={field.name}>End Time</label>
                                        </span>
                                        {getFormErrorMessage(field.name)}
                                    </div>
                                )}
                            />
                        </Col>
                        {/* End date */}
                        <Col xl={3} lg={3} md={3} >
                            <Controller
                                name="end_date"
                                control={control}
                                rules={{ required: 'End date is required.' }}
                                render={({ field, fieldState }) => (
                                    <div className="d-flex flex-column justify-content-center">
                                        <span className="p-float-label">
                                            <Calendar
                                                inputId={field.name}
                                                value={field.value}
                                                onChange={field.onChange}
                                                dateFormat="dd/mm/yy"
                                                className={classNames({ 'p-invalid': fieldState.error })}
                                                style={{ width: '100%' }}
                                            />
                                            <label htmlFor={field.name}>End Date</label>
                                        </span>
                                        {getFormErrorMessage(field.name)}
                                    </div>
                                )}
                            />
                        </Col>
                    </Row>

                    {/* Repeat type and repeat every */}
                    <Row className="d-flex justify-content-center">
                        <Col xl={12} lg={12} md={12} className="d-flex justify-content-center">
                            <Controller
                                name="repeat_every"
                                control={control}
                                rules={{
                                    required: true,
                                }}
                                render={({ field, fieldState }) => (
                                    <div className='d-flex flex-column justify-content-center'>
                                        <span className="p-float-label">
                                            <InputNumber
                                                inputStyle={{
                                                    width: '130px',
                                                }}
                                                onValueChange={(e: any) => field.onChange(e.value)}
                                                mode="decimal"
                                                showButtons
                                                min={1} max={100}
                                                id={field.name}
                                                value={field.value}
                                                onBlur={field.onChange}
                                                useGrouping={false}
                                            />
                                            <label htmlFor={field.name}>Repeat Every.</label>

                                        </span>
                                        {errors[field.name] ? (errors[field.name]?.type === "required" ?
                                            <small className="p-error">field is required&nbsp;</small>
                                            : errors[field.name]?.message)
                                            : ""
                                        }
                                    </div>
                                )}
                            />
                            <Controller
                                name="repeat_type"
                                control={control}
                                rules={{ required: 'City is required.' }}
                                render={({ field, fieldState }) => (
                                    <div className='d-flex flex-column'>
                                        <Dropdown
                                            id={field.name}
                                            value={field.value}
                                            optionLabel="name"
                                            options={REPEAT_TYPE}
                                            focusInputRef={field.ref}
                                            onChange={(e) => {
                                                field.onChange(e.value)
                                                handleRepeatTypeChange(e.value)
                                            }}
                                            className={classNames({ 'p-invalid': fieldState.error })}
                                        />
                                    </div>
                                )}
                            />
                            {getFormErrorMessage('city')}
                        </Col>
                    </Row>

                    {showRepeatOn &&
                        <Row className="mb-3">
                            <Col xl={12} lg={12} md={12} className="mt-4">
                                <Controller
                                    name="repeat_on"
                                    control={control}
                                    rules={{ required: 'Week day is required.' }}
                                    render={({ field, fieldState }) => (

                                        <div className="d-flex flex-column justify-content-center align-items-center">
                                            <SelectButton
                                                {...field}
                                                id={field.name}

                                                style={{
                                                    flexWrap: "wrap"
                                                }}
                                                multiple
                                                options={REPEAT_ON}
                                                optionLabel="name"
                                                className={classNames('d-flex justify-content-center', { 'p-invalid': fieldState.error })}
                                            />
                                            {getFormErrorMessage(field.name)}

                                        </div>
                                    )}
                                />
                            </Col>
                        </Row>
                    }


                    <Row>
                        <div className='d-flex justify-content-center mt-4'>
                            <Button className='btn' style={{ backgroundColor: "#082979", color: "#fff" }} type="submit" name="submit">
                                {isUpdateRequest ? "Update Training" : "Add Training"}
                            </Button>
                        </div>
                    </Row>
                    <ConfirmDialog
                        header="Update Trainings"
                        acceptLabel='Ok'
                        rejectLabel='Cancel'
                        onShow={() => setShowConfirmDialog(true)}
                        onHide={reject}
                        visible={showConfirmDialog}
                        accept={accept}
                        reject={reject}
                        style={{ width: '50vw' }}
                        breakpoints={{ '1100px': '75vw', '960px': '100vw' }}
                        message={messageTemplate}

                    />
                </form>
            </Card>
        </Container>
    )

}
